import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import FullScreenLoader from "../../../components/common/FullScreenLoader";

/* =========================================================
   ADMIN INVITATION LOGIN
   ========================================================= */

export default function AdminInvitationLoginPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  const hasStarted = React.useRef(false);

  const email = String(searchParams.get("email") || "").trim();

  /* =====================================================
     START AUTH0 LOGIN
     ===================================================== */

  React.useEffect(() => {
    if (isLoading || hasStarted.current) {
      return;
    }

    /*
     * If Auth0 already has an authenticated session,
     * continue directly with the normal LEG-UP
     * post-login resolver.
     */
    if (isAuthenticated) {
      hasStarted.current = true;

      navigate("/post-login", {
        replace: true,
      });

      return;
    }

    hasStarted.current = true;

    loginWithRedirect({
      authorizationParams: {
        prompt: "login",

        ...(email
          ? {
              login_hint: email,
            }
          : {}),
      },

      appState: {
        returnTo: "/post-login",
      },
    }).catch((error) => {
      console.error("Admin invitation login failed:", error);

      hasStarted.current = false;
    });
  }, [email, isAuthenticated, isLoading, loginWithRedirect, navigate]);

  /* =====================================================
     RENDER
     ===================================================== */

  return <FullScreenLoader text="Preparing your administrator account..." />;
}
